export default __webpack_public_path__ + "static/media/330_portfolio04-jp-mobile.87188185.png";